/* eslint-disable sort-keys-fix/sort-keys-fix */
import { COMMUNITY_PAGES_PATH_PREFIX, type CommunityData } from "./types"

const S3_PREFIX = "https://media.werz.at/community-assets/doof/"

const DOOF: CommunityData = {
  code: "doof",
  inviteCode: "doof",
  name: "Doof",
  thumbnail: "",
  favicon: "",
  defaultCurrency: "SEK",
  url: `${COMMUNITY_PAGES_PATH_PREFIX}/doo-018`,
  waitlist: false,
  socials: {},
  styles: {
    global: {
      counterColor: "#000000",
      werzLogoColor: "#000",
      logo: {
        src: `${S3_PREFIX}web-logo.jpg`,
        styles: "w-[160px] h-[86.81px]",
      },
      alternativeLogo: {
        src: `${S3_PREFIX}web-alternative-logo.png`,
        styles: "w-[160px] h-[86.81px]",
      },
      modalWindow: {
        container: "",
        title: "",
        subtitle: "",
      },
      bgColor: "#ffffff",
      asideBg: "#ffffff",
      asideStyles: "border-r border-[#d5d5d5]",
      contentBg: "#ffffff",
      contentBoxShadow: "",
      bgDesktop: `${S3_PREFIX}web-background.mp4?type=video`,
      bgMobile: `${S3_PREFIX}web-background-mobile.mp4?type=video`,
      nonMemberBg: `${S3_PREFIX}web-background-non-member.mp4?type=video`,
      mainFont: "font-['HelveticaNeueRegular']",
      primaryButton:
        "bg-[#000000] border border-[#8d8d8d] rounded-[8px] px-[18px] py-[18px] !text-[#ffffff] font-['BrightonvintageRegular'] !text-[16px] text-left leading-[100%]",
    },
    navigation: {
      iconsColor: "#000000",
      sideBarSeparator: "border-r-[1px] border-[#d5d5d5]",
      separator: "border-[#d5d5d5]",
      item: "font-['HelveticaNeueRegular'] text-[16px] text-[#000000] text-left leading-[100%] gap-x-[10px] text-opacity-50 text-center border-b border-[#d5d5d5] !pl-0 !py-3",
      itemSelected: " !text-opacity-100",
    },
    communityLanding: {
      container: "!bg-[#ffffff] border-0 !pb-8",
      titles: "text-[#000000] font-['BrightonvintageRegular'] text-[26px] text-left leading-[120%]",
      emptyOrLoadingState:
        "!mx-4 sm:!mx-8 text-[#444444] font-['HelveticaNeueRegular'] text-[14px] text-left leading-[120%]",
      announcementsV2: {
        sectionContainer: "py-4 sm:py-8 !m-0 space-y-0 !border-0 !border-b border-[#d5d5d5]",
        sectionTitle:
          "text-[#000000] font-['BrightonvintageRegular'] text-[26px] text-left leading-[120%] pl-4 sm:pl-8 !mb-4 sm:mb-6",
        scrollMenu: {
          container: "content-start hide-scroll pl-4 sm:pl-8 pr-6 sm:pr-8 gap-x-4",
          wrapper: "relative group",
          item: "w-fit",
        },
        item: {
          container:
            "min-w-[calc(100vw-48px)] sm:min-w-[256px] sm:max-w-[256px] overflow-hidden bg-[#ffffff]",
          mediaContainer: "w-full sm:w-[256px] !aspect-square relative",
          media: "w-full !aspect-square object-cover rounded-[16px]",
          placeholderMedia: "w-full !aspect-square bg-gray-400 rounded-[16px]",
          content: "flex flex-col py-4 bg-transparent",
          title:
            "text-[#000000] font-['BrightonvintageRegular'] text-[16px] text-left leading-[120%]",
          subtitle:
            "text-[#444444] font-['HelveticaNeueRegular'] text-[14px] text-left leading-[120%] mt-2",
        },
      },
      eventsV2: {
        sectionContainer: "py-4 sm:py-8 !m-0 space-y-0 !border-0 !border-b border-[#d5d5d5]",
        sectionTitle:
          "text-[#000000] font-['BrightonvintageRegular'] text-[26px] text-left leading-[120%] pl-4 sm:pl-8 !mb-4 sm:mb-6",
        scrollMenu: {
          container:
            "content-start hide-scroll pl-4 sm:pl-8 pr-6 sm:pr-8 !h-full sm:!h-[128px] flex-row gap-6",
          wrapper: "relative group w-full",
          item: "w-fit",
        },
        item: {
          container:
            "flex sm:flex-row flex-col w-[calc(100vw-56px)] sm:!w-[428px] h-full overflow-hidden bg-[#ffffff]",
          mediaContainer:
            "w-full sm:!w-[228px] sm:flex-shrink-0 relative overflow-hidden rounded-[16px]",
          media: "w-full !aspect-video object-cover rounded-[16px]",
          placeholderMedia: "w-full !aspect-video bg-gray-400 rounded-[16px]",
          content: "flex flex-col px-4 bg-transparent",
          title:
            "text-[#000000] font-['BrightonvintageRegular'] text-[16px] text-left leading-[120%]",
          subtitle:
            "text-[#444444] font-['HelveticaNeueRegular'] text-[14px] text-left leading-[120%] mt-2",
          location:
            "text-[#444444] font-['HelveticaNeueRegular'] text-[14px] text-left leading-[120%] mt-1",
          date: "text-[#444444] font-['HelveticaNeueRegular'] text-[14px] text-left leading-[120%] mt-2",
        },
      },
      shop: {
        container: "py-4 sm:py-8 !pb-16 !m-0 space-y-0 !border-0 overflow-hidden",
        title:
          "text-[#000000] font-['BrightonvintageRegular'] text-[24px] text-left leading-[120%]",
        text: "text-[#000000] font-['HelveticaNeueRegular'] text-[14px] text-left leading-[120%]",
        customShopImageStyle: "",
        sectionTitle:
          "text-[#000000] font-['BrightonvintageRegular'] text-[26px] text-left leading-[120%] !mb-4 sm:mb-6",
      },
    },
    comingSoon: {
      bgColor: "",
      hero: {
        desktop: "",
        mobile: "",
        style: "",
      },
      logo: {
        desktop: "",
        mobile: "",
        style: "",
      },
      werzLogoColor: "",
      title: "",
      text: "",
      button: "",
      input: {
        base: "",
        border: "",
        borderFocus: "",
        borderError: "",
        errorText: "",
      },
      error: "",
      footerText: "",
      skipButton: "",
      modal: {
        container: "",
        title: "",
        text: "",
        width: "",
        backdrop: "",
        otpInput: "",
        otpBorder: "",
        otpBorderFocus: "",
      },
    },
    eventV2: {
      container: "flex flex-col !bg-[#ffffff] border border-[#d5d5d5] !pb-8",
      eventInfo: {
        container: "flex flex-col sm:flex-row gap-4 sm:gap-6 sm:p-8 p-4 border-b border-[#d5d5d5]",
        media: "sm:!w-[320px] !w-full !h-[180px] object-cover sm:mb-4 rounded-[16px] !border-0",
        title:
          "text-[#000000] font-['BrightonvintageRegular'] text-[26px] text-left leading-[120%]",
        subtitle:
          "text-[#444444] font-['HelveticaNeueRegular'] text-[14px] text-left leading-[120%] mb-4 mt-2",
        button:
          "bg-[#000000] border border-[#8d8d8d] rounded-[8px] px-[18px] py-[18px] gap-y-[6px] !w-fit mb-4 sm:mb-0 text-[#ffffff] font-['BrightonvintageRegular'] text-[16px] text-left leading-[100%]",
        questions: "text-[14px] text-left leading-[120%] text-[#000000]",
      },
      about: {
        container: "flex flex-col gap-4 sm:p-8 p-4 border-b border-[#d5d5d5]",
        header:
          "text-[#000000] font-['BrightonvintageRegular'] text-[24px] text-left leading-[120%]",
        text: "text-[#000000] font-['HelveticaNeueRegular'] text-[14px] text-left leading-[120%] mb-4 w-full",
      },
      location: {
        container: "flex flex-col gap-4 sm:p-8 p-4 border-b border-[#d5d5d5]",
        header:
          "text-[#000000] font-['BrightonvintageRegular'] text-[24px] text-left leading-[120%]",
        text: "text-[#000000] font-['HelveticaNeueRegular'] text-[14px] text-left leading-[120%] mb-4 max-w-[652px] w-full",
        map: "h-[206px] overflow-hidden gap-y-[10px] !rounded-[16px] border-0 flex-shrink",
        mapPinColor: "#000000",
        mapStrokeColor: "#00000000",
      },
      downloadWERZ: {
        container: "flex flex-col gap-4 sm:p-8 p-4",
        header:
          "text-[#000000] font-['BrightonvintageRegular'] text-[24px] text-left leading-[120%]",
        text: "text-[#000000] font-['HelveticaNeueRegular'] text-[14px] text-left leading-[120%]",
      },
      tickets: {
        header:
          "text-[#000000] font-['BrightonvintageRegular'] text-[24px] text-left leading-[120%] px-4 sm:px-8 pt-4 sm:pt-8 mb-2 sm:mb-4 flex justify-between items-center",
        outerContainer: "flex flex-col !bg-[#ffffff] !pb-8",
        innerContainer: "flex flex-col overflow-hidden px-4 sm:px-8",
        accessCode: {
          button:
            "bg-[#ffffff] border border-[#8d8d8d] rounded-[8px] px-[16px] py-[16px] text-[#000000] font-['BrightonvintageRegular'] text-[14px] text-left leading-[100%] !w-fit",
        },
        ticket: {
          container:
            "flex flex-row justify-between leading-auto !bg-[#ffffff] border-b border-[#d5d5d5] py-4",
          mediaContainer: "!hidden",
          media: "!hidden",
          name: "text-[#000000] font-['BrightonvintageRegular'] text-[16px] text-left leading-[120%] mb-1",
          description:
            "text-[#444444] font-['HelveticaNeueRegular'] text-[14px] text-left leading-[120%] mb-1 flex flex-row",
          price:
            "text-[#444444] font-['BrightonvintageRegular'] text-[16px] text-left leading-[120%]",
          quantity:
            "text-[#000000] font-['BrightonvintageRegular'] text-[14px] text-left leading-[100%]",
          status:
            "text-[#444444] font-['BrightonvintageRegular'] text-[16px] text-left leading-[120%]",
          counterContainer:
            "bg-[#ffffff] border border-[#8d8d8d] rounded-[8px] px-[16px] py-[16px] gap-x-[16px] !w-fit !h-10",
          button:
            "bg-[#ffffff] border border-[#8d8d8d] rounded-[8px] px-[16px] py-[16px] text-[#000000] font-['BrightonvintageRegular'] text-[14px] text-left leading-[100%] !w-fit",
          plusMinusColor: "#000000",
        },
      },
    },
  },
}

export default DOOF
